import { DEFAULT_COLUMN_STYLE } from '~/components/MultiGrid/constants';
import { IBaseFieldData, IColumnStyle } from '~/components/MultiGrid/types';

export const BILLING_FIELDS_ORDER = [
  'subscription_id',
  'billing_date',
  'status',
  'amount',
  'plan_name',
  'actions',
];

export const BILLING_ALL_FIELDS: Record<IBaseFieldData['value'], IBaseFieldData & IColumnStyle> =
  Object.freeze({
    subscription_id: {
      label: 'Invoice ID',
      value: 'subscription_id',
      ...DEFAULT_COLUMN_STYLE,
      width: 350,
      isStatic: true,
    },
    billing_date: {
      label: 'Billing date',
      value: 'billing_date',
      ...DEFAULT_COLUMN_STYLE,
      width: 150,
    },
    status: {
      label: 'Status',
      value: 'status',
      ...DEFAULT_COLUMN_STYLE,
      width: 120,
    },
    amount: {
      label: 'Amount',
      value: 'amount',
      ...DEFAULT_COLUMN_STYLE,
      width: 120,
    },
    plan_name: {
      label: 'Plan',
      value: 'plan_name',
      ...DEFAULT_COLUMN_STYLE,
      width: 150,
    },
    actions: {
      label: 'Actions',
      value: 'actions',
      ...DEFAULT_COLUMN_STYLE,
      width: 100,
    },
  });
